module Client.ContractPage.ContractPageView

open FSharpPlus
open Fable.React
open Fable.React.Props
open Fulma
open PortalLibs.Client.Components.Dropdown
open Model
open Shared
open ContractPageModel
open PortalLibs.Client.Util
open Feliz
open PortalLibs.Shared

let jobDetailsView model applicationSettings contract aiInfos isSuperUser isDemo dispatch =
  let tab name selected tab =
    Tabs.tab [ Tabs.Tab.IsActive(selected = tab) ] [
      a [ OnClick(fun _ -> tab |> TabSelected |> dispatch) ] [
        str name
      ]
    ]

  div [ Style [
          MinHeight "150px"
          MarginTop "10px"
        ] ] [
    div [ Style [
            Display DisplayOptions.Flex
            JustifyContent "space-between"
            FlexWrap "wrap"
            MarginBottom "5px"
          ] ] [
      strong [] [
        $"Est Completion: %s{contract.EstCompletion
                             |> prettyPrintDateOptionLong}"
        |> str
      ]
      strong [ Style [
                 if CostAndBilling.isOver30Days contract then
                   yield Color "Red"
               ] ] [
        $"Last Bill Date: %s{contract.LastBillDate |> prettyPrintDateOptionLong}"
        |> str
      ]
    ]
    Tabs.tabs [ Tabs.CustomClass "wrap-tabs" ] [
      yield tab "Overview" model.SelectedTab Overview
      yield tab "Change Orders" model.SelectedTab Tab.ChangeOrders
      yield tab "AR and Cash Flow" model.SelectedTab ARAndCashFlow
      yield tab "Cost Of Construction" model.SelectedTab CostOfConstruction
      yield tab "Cost and Billing" model.SelectedTab CostAndBilling
      yield tab "Profit Fade" model.SelectedTab ContractProfitFadeTab
      yield tab "Average Rate" model.SelectedTab AverageRate
      yield tab "Purchase Orders" model.SelectedTab Tab.PurchaseOrders
      if isDemo then
        yield tab "AI" model.SelectedTab AI
      if applicationSettings.ContractSettings.CostAndBillingForecasting then
        yield tab "Scheduling" model.SelectedTab Scheduling
    ]
    React.fragment [
      yield
        match model.SelectedTab with
        | Overview -> Overview.view applicationSettings.ContractSettings contract
        | Tab.ChangeOrders ->
          ChangeOrders.Main.View model.ChangeOrderHeaders model.ChangeOrderItems model.ChangeOrderItemLines contract
        | ARAndCashFlow -> ARAndCashFlow.View model contract
        | CostOfConstruction ->
            CostOfConstruction.CostOfConstruction.CostOfConstructionView
              {| Model = model
                 ContractSettings = applicationSettings.ContractSettings
                 IsSuperUser = isSuperUser
                 Contract = contract
                 Dispatch = dispatch |}
        | AverageRate ->
          AverageRate.View
            {| JobCosts = model.JobCosts
               RemainingHoursEnabled = applicationSettings.AverageLaborRate_RemainingHours
               Contract = contract
               Dispatch = dispatch |}
        | CostAndBilling -> CostAndBilling.View model applicationSettings.ContractSettings isDemo contract dispatch
        | ContractProfitFadeTab -> ContractProfitFade.View model.ContractProfitFades contract
        | Tab.PurchaseOrders ->
          PurchaseOrders.PurchaseOrders.View
            model
            applicationSettings.ContractSettings
            contract
            (model.PurchaseOrders |> Map.tryFind contract.Id)
            dispatch
        | AI -> AI.view model contract aiInfos
        | Scheduling -> Scheduling.View model contract
    ]
  ]

let OnlyOneDropDownSpecific =
  OnlyOneDropdownGeneric<Contract, unit, obj, int64>

let content model applicationSettings aiInfos isSuperUser isDemo dispatch contracts =
  div [] [
    div [ Style [ MaxWidth "400px" ] ] [
      OnlyOneDropDownSpecific(
        {| Title = DropdownOnly
           Items =
            contracts
            |> Map.toList
            |>> snd
            |> ItemList
           DisplayValue =
            (fun (j: Model.Contract) ->
              $"%s{Option.emptyStrIfNone j.Number} - %s{Option.emptyStrIfNone j.Description}")
           SelectMode =
            SingleSelect
              { UpdateModel =
                  Simple (fun jobOpt ->
                    jobOpt
                    |>> (fun contract -> contract.Id)
                    |> ContractSelected
                    |> dispatch)
                SelectedItem = SelectedItem.ItemId(model.SelectedContractId, (fun id contract -> id = contract.Id))
                LinkUrl = None }
           Searchable = true
           Type = Standard
           Key = "ContractPageViewContractDropdown" |}
      )
    ]
    (match model.SelectedContractId
           >>= fun contractId -> contracts |> Map.tryFind (string contractId)
       with
     | None ->
       div [ Style [
               MinHeight "150px"
               TextAlign TextAlignOptions.Center
               MarginTop "100px"
             ] ] [
         (if Option.isSome model.SelectedContractId then
            "Contract is loading..."
          else
            "Please select a Contract.")
         |> str
       ]
     | Some contract -> jobDetailsView model applicationSettings contract aiInfos isSuperUser isDemo dispatch)
  ]

let ContractPageView =
  React.memo (
    "ContractPageView",
    (fun (props: {| Model: ContractPageModel.Model
                    ApplicationSettings: ApplicationSettings
                    Contracts: Map<string, Contract> option
                    AiInfos: Map<ContractId, ContractAiInfo>
                    IsDemo: bool
                    IsSuperUser: bool
                    Dispatch: Msg -> unit |}) ->
      div [ ClassName "contract-page"
            Style [ MarginTop "25px" ] ] [
        loadingMessageBoxOrContent
          "Loading Contracts..."
          (content props.Model props.ApplicationSettings props.AiInfos props.IsSuperUser props.IsDemo props.Dispatch)
          props.Contracts
      ])
  )